export class MyRequest {
  id: string;
  sender: string;
  receiver: string | string[];
  type: string;
  status: string;
  detail: any | null;
  incoming: boolean;
  createdTime: string;
  messageID: string | null;
  headerMsgId: string | null | undefined;

  constructor(
    id: string,
    sender: string,
    receiver: string | string[],
    type: string,
    status: string,
    detail: any | null,
    incoming: boolean,
    createdTime: string = new Date().toISOString(),
    messageID: string,
    headerMsgId?: string,
  ) {
    this.id = id;
    this.sender = sender;
    this.receiver = receiver;
    this.type = type;
    this.status = status;
    this.detail = detail;
    this.incoming = incoming;
    this.createdTime = createdTime;
    this.messageID = messageID;
    this.headerMsgId = headerMsgId;
  }
}
